import axiosClient from "../../../../api/axiosClient";

export const fetchUsers = async (token) => {
  axiosClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  const response = await axiosClient.get("/users"); // endpoint API users
  return response.data.data; // pastikan API mengembalikan array user
};
